import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {dataManager} from "../../Broadtask";
import ProcessCard from "./ProcessCard";
import {buttonStyle, sectionStack} from "../../../AppStyles";

const ProcessManagerPane = (props) => {

    const navigate = useNavigate();

    const [processes, setProcesses] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function onRefresh()
    {
        reload(true);
    }

    function reload(force)
    {
        dataManager.getProcessManager().getProcesses(force, (processes) => {
            setProcesses(processes);
        });
    }

    function onCreate()
    {
        navigate("../processes/create");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%" alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/process.png" width={32} height={32}/>
                    <Typography variant="h6">Processes</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onCreate}
                            sx={buttonStyle}
                            startIcon={<AddCircleOutlineIcon />}>CREATE</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" alignItems="center" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={{ flexWrap: "wrap", backgroundColor: '#2A333A'}}>
                {
                    processes === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        processes.map(nextProcess => {
                            return (<ProcessCard key={"process_" + nextProcess.processUID} entry={nextProcess} />)
                        })
                }

            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default ProcessManagerPane;
